import { useCallback, useEffect, useMemo, useState } from "react";
import { DeleteTwoTone, EditTwoTone } from "@ant-design/icons";
import {
    Button,
    message,
    Row,
    Col,
    Typography,
    Dropdown,
    Menu,
    Popconfirm,
    Modal,
    Form,
    Input,
    Select,
    Switch,
    DatePicker,
    TimePicker,
} from "antd";
import ListTable from "../../common/ListTable";
import AppContent from "../../common/AppContent";
import AppPageHeader from "../../common/PageHeader";
import ExtraContent from "../Configuration/CommonComponents/ExtraContent";
import FilterComponent from "../Configuration/CommonComponents/FilterComponent";
import { getData, postData, deleteData, putData } from "../../apiServices/common";
import {
    BUYER_INSPECTION_DATE_LIST_ENDPOINT,
    BUYER_INSPECTION_DATE_ADD_ENDPOINT,
    BUYER_INSPECTION_DATE_EDIT_ENDPOINT,
    BUYER_INSPECTION_DATE_DELETE_ENDPOINT,
    GET_STYLE_LIST_ENDPOINT,
} from "../../apiServices/API_ENDPOINTS";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import moment from "moment";
import CustomDatePicker from "common/CustomDatePicker";
import { cglFormatDate } from "utils/functions";

const BuyerInspectionDate = () => {

  const onDateChange = (date, dateString) => {
    console.log(date, dateString);
  };
  
  const onTimeChange = (time, timeString) => {
    console.log(time, timeString); // You can handle the selected time here
  };
  
  // Router
  const location = useLocation();
  const routerPath = location ? location.pathname : null;

  // States
  const [showFilter, setShowFilter] = useState(
    localStorage.getItem("filter_status") && routerPath
      ? JSON.parse(localStorage.getItem("filter_status"))[routerPath]
      : false,
  );
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [tableData, setTableData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [tableError, setTableError] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [metaData, setMetaData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ styleList, setStyleList ] = useState();
  const [buyerInput, setBuyerInput] = useState("");
  const [salesContractInput, setSalesContractInput] = useState("");

  const handleSelectChange = (style_id) => {
    // console.log("style_id", style_id);
    // Find the style object that matches the selected style_id
    const selectedStyle = styleList.find(style => style.id === style_id);
    console.log("selectedStyle", selectedStyle);
    if (selectedStyle) {
      // Extract relevant fields (adjust fields based on your actual data structure)
      const buyerValue = selectedStyle?.buyer_info?.name;
      const salesContractValue = selectedStyle?.active_sales_contract_map_info?.active_sales_contract_info?.reference_no;
  
      // Update the form fields using setFieldsValue
      buyer_inspection_dateForm.setFieldsValue({
        buyer: buyerValue,
        sales_contract: salesContractValue,
      });
    } 
  };

  // Antd
  const [buyer_inspection_dateForm] = Form.useForm();
  const { Option } = Select;
  const { Title } = Typography;

  // // Redux
  // const filterData = useSelector(({ filter }) => filter.filterData);

  // Filter open/close status update in localStorage
  useEffect(() => {
    const filterStatus = localStorage.getItem("filter_status");
    const parsedFilterStatus = filterStatus ? JSON.parse(filterStatus) : {};

    if (showFilter) {
      parsedFilterStatus[routerPath] = true;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    } else {
      parsedFilterStatus[routerPath] = false;
      localStorage.setItem("filter_status", JSON.stringify(parsedFilterStatus));
    }
  }, [showFilter, routerPath, location]);

  const getAllBuyerInspectionDate = useCallback(
    async (filterValues) => {
      const payload = {
        page: filterValues?.page || currentPage,
        ...filterValues,
      }

      setLoading(true);
      setTableError(null);

      const query = `${BUYER_INSPECTION_DATE_LIST_ENDPOINT}`;
      const bodyData = {
        ...payload,
      };

      const response = await getData(query, false, bodyData);
      if (response?.status === 200) {
        setLoading(false);
        setMetaData({
          defaultPageSize: response?.data?.data?.per_page,
          current: response?.data?.data?.current_page,
          defaultCurrent: response?.data?.data?.current_page,
          total: response?.data?.data?.total,
        });
        setTableData(response?.data?.data?.data);
      } else {
        setLoading(false);
        setTableError("Could not load this list.");
        message.error("Error getting Buyer Inspection Date data");
      }
    },
    [currentPage],
  );

  const getAllStyles = async (filterValues) => {
    setLoading(true);

    const query = `${GET_STYLE_LIST_ENDPOINT}`;
    const payload = {
      ...filterValues,
    }

    const response = await getData(query, false, payload);
    if (response?.status === 200) {
      setLoading(false);
      // const filteredStyleListData = response?.data?.data?.data?.filter(item => item.status === "Yes");
      console.log("mamuuu", response?.data?.data?.data);
      setStyleList(response?.data?.data?.data);
    } else {
      setLoading(false);
      message.error("Error getting warehouse data");
    }
  };

  console.log("Style List gulo dekhi", styleList);

  

  // console.log("Line List dekhi", salesContractList);

  // Effects
  useEffect(() => {
    getAllBuyerInspectionDate();
    getAllStyles();
  }, [refresh, getAllBuyerInspectionDate]);

  const onModalOpen = () => {
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    buyer_inspection_dateForm.resetFields();
    setIsModalOpen(false);
    setIsEdit(false);
  };

  const refetch = () => {
    setRefresh(refresh + 1);
  };

  const deleteSelectedbuyer_inspection_date = async (id) => {
    setLoading(true);
    const response = await deleteData(`${BUYER_INSPECTION_DATE_DELETE_ENDPOINT}/${id}`);

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Buyer Inspection Date Deleted Successfully");
      refetch();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const editSelectedbuyer_inspection_date = async (formValues) => {
    setLoading(true);

    const bodyData = {
      style_id: formValues?.style_id,
      buyer_inspection_date: moment(formValues?.buyer_inspection_date).format('YYYY-MM-DD'),
      buyer_inspection_time: moment(formValues?.buyer_inspection_time).format('HH:mm'),
      result: formValues?.result ? formValues?.result : null,
    };

    const response = await putData(
      `${BUYER_INSPECTION_DATE_EDIT_ENDPOINT}/${formValues?.id}`,
      bodyData,
    );

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Buyer Inspection Date Edited Successfully");
      refetch();
      buyer_inspection_dateForm.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const createNewbuyer_inspection_date = async (formValues) => {
    setLoading(true);

    const bodyData = {
      style_id: formValues?.style_id,
      buyer_inspection_date: moment(formValues?.buyer_inspection_date).format('YYYY-MM-DD'), // Format as 'Y-m-d'
      buyer_inspection_time: moment(formValues?.buyer_inspection_time).format('HH:mm'),
      result: formValues?.result ? formValues?.result : null,
    };

    const response = await postData(BUYER_INSPECTION_DATE_ADD_ENDPOINT, bodyData);

    if (response && response?.code === 200) {
      setLoading(false);
      message.success("Buyer Inspection Date Created Successfully");
      refetch();
      buyer_inspection_dateForm.resetFields();
      onCloseModal();
    } else {
      setLoading(false);
      message.error("Something went wrong");
    }
  };

  const openModalForEdit = (record) => {
    setIsEdit(true);

    console.log("recordsss", record);

    buyer_inspection_dateForm.setFieldsValue({
      id: record?.id,
      style_id: record?.style_id,
      buyer_inspection_date: moment(record?.buyer_inspection_date, 'YYYY-MM-DD'), // Use moment to set the date
      buyer_inspection_time: moment(record?.buyer_inspection_time, 'HH:mm'),
      result: record?.result ? record?.result : null,
    });
    // Trigger handleSelectChange to populate buyer and sales contract
    handleSelectChange(record?.style_id);
    setIsModalOpen(true);
  };

  const changePage = (newPage) => {
    setCurrentPage(newPage);
    refetch();
  };

  const tableColumns = [
    {
      title: "Style Name",
      dataIndex: ["style_info", "style_no"],
      key: "style_id",
    },
    {
      title: "Buyer",
      dataIndex: ["style_info", "buyer_info", "name"],
      key: "buyer",
    },
    {
      title: "Sales Contract / Sub-Contract Ref No",
      dataIndex: ["style_info", "active_sales_contract_map_info", "active_sales_contract_info", "reference_no"],
      key: "sales_contract",
    },
    {
      title: "Buyer Inspection Date",
      dataIndex: ["buyer_inspection_date"],
      key: "buyer_inspection_date",
      render: (value) => cglFormatDate(value)
    },
    {
      title: "Buyer Inspection Time",
      dataIndex: ["buyer_inspection_time"],
      key: "buyer_inspection_time",
    },
    {
      title: "Result",
      dataIndex: ["result"],
      key: "result",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => {
        return (
          <Dropdown.Button
            overlay={
              <Menu
                items={[
                  {
                    label: (
                      <Popconfirm
                        title="Are you sure you want to delete?"
                        onConfirm={() => {
                          deleteSelectedbuyer_inspection_date(record?.id);
                        }}
                      >
                        <span>
                          <DeleteTwoTone />
                        </span>
                        <span
                          style={{
                            color: "red",
                            marginLeft: 5,
                          }}
                        >
                          Delete
                        </span>
                      </Popconfirm>
                    ),
                    key: "1",
                    
                  },
                  {
                    label: (
                      <>
                        <span>
                          <EditTwoTone />
                        </span>
                        <span
                          type="button"
                          style={{ marginLeft: 5 }}
                          onClick={() => {
                            openModalForEdit(record);
                          }}
                        >
                          Edit
                        </span>
                      </>
                    ),
                    key: "2",
                    
                  },
                ]}
              />
            }
          ></Dropdown.Button>
        );
      },
    },
  ];

  const memoizedCustomFilter = useMemo(
    () => (
      <FilterComponent
          tableData={tableData}
          filterAPI={getAllBuyerInspectionDate}
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          filterName="buyer_inspection_date"
        />
    ),
    [showFilter],
  );

  return (
    <>
      <AppContent
        header={
          <AppPageHeader
            extra={
              <ExtraContent
                refresh={refresh}
                setRefresh={setRefresh}
                handleAddItemOpen={onModalOpen}
                
                addButtonText="Add New"
                showFilter={showFilter}
                setShowFilter={setShowFilter}
              />
            }
            title={<Title level={5}>Buyer Inspection Date</Title>}
          />
        }
        content={
          <>
            {memoizedCustomFilter}

            <div className="table" style={{ marginTop: 10 }}>
              <ListTable
                loading={loading}
                error={tableError}
                onRetry={() => refetch()}
                emptyText="No records to show yet."
                dataSource={tableData}
                columns={tableColumns}
                pagination={{
                  showSizeChanger: false,
                  defaultPageSize: metaData?.defaultPageSize,
                  current: metaData?.current,
                  onChange: (newPage) => {
                    changePage(newPage);
                  },
                  defaultCurrent: metaData?.defaultCurrent,
                  total: metaData?.total,
                }}
              />
            </div>
          </>
        }
      />
      <Modal
        open={isModalOpen}
        title={isEdit ? "Edit Buyer Inspection Date" : "Create Buyer Inspection Date"}
        onCancel={() => {
          onCloseModal();
        }}
        maskStyle={{ backdropFilter: "blur(4px)" }}
        footer={null}
      >
        <Form
          form={buyer_inspection_dateForm}
          layout="vertical"
          onFinish={isEdit ? editSelectedbuyer_inspection_date : createNewbuyer_inspection_date}
        >
          <Row gutter={6}>
            <Col span={24}>
              <Form.Item name="id" hidden />
              <Form.Item
                name="style_id"
                placeholder="Select a Style"
                label="Select a Style"
                rules={[
                  {
                    required: true,
                    message: "Style is Required",
                  },
                ]}
              >
                <Select
                  placeholder="Select a Style"
                  showSearch
                  style={{width: "100%"}}
                  onSearch={(value) => getAllStyles({style_no: value})}
                  onChange={(style_id) => handleSelectChange(style_id)}
                  optionFilterProp="children"
                >
                  {styleList?.map((item) => (
                    <Option key={item.id} value={item.id}>{item.style_no}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="buyer"
                placeholder="Buyer"
                label="Buyer"
              >
                <Input disabled={true} value={buyerInput} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="sales_contract"
                placeholder="Sales Contract"
                label="Sales Contract"
              >
                <Input disabled={true} value={salesContractInput} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="buyer_inspection_date"
                placeholder="Buyer Inspection Date"
                label="Buyer Inspection Date"
                rules={[
                  {
                    required: true,
                    message: "Buyer Inspection Date is Required",
                  },
                ]}
              >
                <CustomDatePicker size="medium" style={{width: "100%"}} onChange={onDateChange} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="buyer_inspection_time"
                placeholder="Buyer Inspection Time"
                label="Buyer Inspection Time"
                rules={[
                  {
                    required: true,
                    message: "Buyer Inspection Time is Required",
                  },
                ]}
              >
                <TimePicker 
                  onChange={onTimeChange} 
                  use12Hours 
                  format="h:mm a" 
                  style={{ width: '100%' }} 
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="result"
                label="Select a Result"
                rules={[
                  {
                    required: false,
                    message: "",
                  },
                ]}
              >
                <Select
                  placeholder="Select a Result"
                  showSearch
                  style={{ width: "100%" }}
                  optionFilterProp="children"
                >
                  <Option value="Passed">Passed</Option>
                  <Option value="Failed">Failed</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={6}>
            <Col span={12}>
              <Button
                type="danger"
                style={{ width: "100%" }}
                onClick={() => {
                  onCloseModal();
                }}
              >
                Discard
              </Button>
            </Col>
            <Col span={12}>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: "100%" }}
                loading={loading}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default BuyerInspectionDate;
